export const tooltipContentClasses =
  // https://github.com/shadcn-ui/ui/issues/2753
  'z-999 rounded-md border-none bg-callout-background px-3 py-1.5 text-sm text-text-primary-on-dark shadow-callout animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2';

export const tooltipArrowClasses = 'fill-callout-background';
